import api from "./api";

const buildQuery = (
  params = {}
) => {
  const searchParams =
    new URLSearchParams();

  Object.entries(
    params
  ).forEach(
    ([key, value]) => {
      if (
        value === undefined ||
        value === null ||
        value === ""
      ) {
        return;
      }

      searchParams.set(
        key,
        String(value)
      );
    }
  );

  const query =
    searchParams.toString();

  return query
    ? `?${query}`
    : "";
};

const facilityService = {
  async getFacilities(
    params = {}
  ) {
    return api.get(
      `/facilities${buildQuery(
        params
      )}`
    );
  },

  async getFacilityById(
    facilityId
  ) {
    return api.get(
      `/facilities/${facilityId}`
    );
  },

  async createFacility(
    payload
  ) {
    return api.post(
      "/facilities",
      payload
    );
  },

  async updateFacility(
    facilityId,
    payload
  ) {
    return api.put(
      `/facilities/${facilityId}`,
      payload
    );
  },

  async setFacilityStatus(
    facilityId,
    isActive
  ) {
    return api.patch(
      `/facilities/${facilityId}/status`,
      {
        isActive,
      }
    );
  },

  async deactivateFacility(
    facilityId
  ) {
    return api.delete(
      `/facilities/${facilityId}`
    );
  },

  /*
  ========================================
  FACILITY SELF-SERVICE
  ========================================
  */

  async getMyFacilityProfile() {
    return api.get(
      "/facilities/profile"
    );
  },

  async createMyFacilityProfile(
    payload
  ) {
    return api.post(
      "/facilities/profile",
      payload
    );
  },

  async updateMyFacilityProfile(
    payload
  ) {
    return api.put(
      "/facilities/profile",
      payload
    );
  },
};

export default facilityService;